module.exports = __webpack_public_path__ + "img/himo.796c90d2.png";